export default __webpack_public_path__ + "static/media/logo3.472c8622.png";